<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'
import { useI18n } from '@/composables/useI18n'

const { preference, cycle } = useTheme()
const { t } = useI18n()

const icon = computed(() => {
  if (preference.value === 'light') return 'mdi-white-balance-sunny'
  if (preference.value === 'dark') return 'mdi-weather-night'
  return 'mdi-theme-light-dark'
})

const label = computed(() => t(`theme.${preference.value}`))
</script>

<template>
  <button class="ui-icon-btn theme-toggle" :title="label" :aria-label="label" @click="cycle">
    <Transition name="spin-fade" mode="out-in">
      <span :key="icon" :class="['mdi', icon]"></span>
    </Transition>
  </button>
</template>

<style scoped>
.spin-fade-enter-active,
.spin-fade-leave-active {
  transition: transform 0.25s var(--ease), opacity 0.2s;
}

.spin-fade-enter-from {
  transform: rotate(-90deg) scale(0.6);
  opacity: 0;
}

.spin-fade-leave-to {
  transform: rotate(90deg) scale(0.6);
  opacity: 0;
}
</style>
